import { render } from "./exerciseList.vue?vue&type=template&id=45a3adc9&scoped=true"
import script from "./exerciseList.vue?vue&type=script&lang=js"
export * from "./exerciseList.vue?vue&type=script&lang=js"

import "./exerciseList.vue?vue&type=style&index=0&id=45a3adc9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a3adc9"]])

export default __exports__